import {
  AppDispatch,
  createSubjectNote,
  createSubjectNoteClear,
  createSubjectNoteRequest,
  getSubjectNoteList,
  getSubjectNoteListRequest } from
"@src/redux";
import { Input, Skeleton, Spin, Timeline } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IoMdCheckmarkCircle, IoMdSend } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { CgNotes } from "react-icons/cg";
import { useCheckPageComponentAccess } from "@src/hooks/index";
type Props = {};

const DockerNoteContainer = (props: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams();
  const { t } = useTranslation();
  const [note, setNote] = useState<string>("");

  const { result: createSubjectNoteResult, loading: createDoctorNote } =
  useSelector(createSubjectNote);
  const { result: dockerLog, loading } = useSelector(getSubjectNoteList);

  const handleSent = () => {
    dispatch(
      createSubjectNoteRequest({
        data: {
          type: "primary",
          content: note,
          subjectId: id
        }
      })
    );
  };
  const handleChange = (e: any) => {
    setNote(e?.target?.value);
  };

  useEffect(() => {
    dispatch(
      getSubjectNoteListRequest({
        filter: { subjectId: id },
        sort: [{ field: "datetime", order: "desc" }]
      })
    );
  }, [id]);

  useEffect(() => {
    if (createSubjectNoteResult?.status === "success") {
      setNote("");
      dispatch(createSubjectNoteClear());
      dispatch(
        getSubjectNoteListRequest({
          filter: { subjectId: id },
          sort: [{ field: "datetime", order: "desc" }]
        })
      );
    }
  }, [createSubjectNoteResult]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column"
        // height: "0vh",
      }}>
      
      <div className="subject-doctor-node-sent-main-container">
        {dockerLog?.items && dockerLog?.items.length > 0 ?
        <Timeline className="timeline-container">
            {dockerLog.items.map((log) =>
          <Timeline.Item
            key={log.id}
            className="timeline-item"
            dot={
            <CgNotes
              size={15}
              color="#8a174c"
              style={{
                border: "2px solid #8a174c",
                padding: "5px",
                borderRadius: "50%"
              }} />}>

            
                <div className="timeline-content">
                  <p className="timeline-date">
                    {moment(log?.datetime).format("DD-MMM-YYYY hh:mm A")}
                  </p>

                  <p className="timeline-name">
                    {log.noteBy?.name}
                    {log.noteBy?.code ? ` - ${log.noteBy?.code}` : ""}
                  </p>

                  <p className="timeline-note">{log.content}</p>
                </div>
              </Timeline.Item>
          )}
          </Timeline> :

        ""}
        
      </div>
      {useCheckPageComponentAccess("create_doctor_notes") &&

      <div className="subject-doctor-node-sent-container">
        {loading ?
        <Skeleton.Input active size="large" style={{ width: "100%" }} /> :

        <>
            <Input.TextArea
            maxLength={100}
            className="doctor-node-sent-input"
            placeholder={t("add_notes")}
            onChange={handleChange}
            value={note} />
          
            {!note?.length ?
          <IoMdSend
            size={30}
            color="#8a174c"
            className="doctor-node-sent-icon"
            style={{ cursor: "not-allowed", opacity: 0.5 }} /> :

          createDoctorNote ?
          <Spin size="small" className="doctor-node-sent-icon" /> :

          <IoMdSend
            size={30}
            color="#8a174c"
            className="doctor-node-sent-icon"
            onClick={handleSent} />}

          
          </>}
        
      </div>}
      
    </div>);

};

export default DockerNoteContainer;